$(document).ready(function () {

  $(document).on('mouseenter', '#site-nav-item--1', function () {
      var $menu = $('#site-nav-item--1');

      if ($menu.length) {

        var $lastItem = $menu.find('.grid__item').last();

        var $titleBlock = $lastItem.find('.h5');
        var $imageLink = $lastItem.find('> div:not(.h5) a');

        if ($lastItem.find('img.megamenu__collection-image').length) return;

        var text = $imageLink.text().replace(/"/g, '').trim();

        if (text.indexOf('Image--') !== -1) {

          var imageUrl = text.split('Image--')[1].trim();

          var $imgWrapper = $('<div class="svg-mask svg-mask--landscape"></div>');
          var $img = $('<img>', {
            src: imageUrl,
            class: 'megamenu__collection-image',
            alt: 'All Collections'
          });

          $imgWrapper.append($img);
          $titleBlock.before(
            $('<a>', {
              href: $imageLink.attr('href')
            }).append($imgWrapper)
          );
          $imageLink.parent().remove();
        }
      }

    });

  function submitForm(event) {
    $(event.target.form).submit();
  }

  $(window).scroll(function () {
    var btn = document.getElementById('toTopBtn');
    if (!btn) return;
    if ($(this).scrollTop() > 20) {
      btn.style.setProperty('opacity', '1', 'important');
      btn.style.setProperty('visibility', 'visible', 'important');
    } else {
      btn.style.setProperty('opacity', '0', 'important');
      btn.style.setProperty('visibility', 'hidden', 'important');
    }
  });

  $("#toTopBtn").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 1000);
    return false;
  });

  $(document).on("click", ".swatch-view-image .swatch-view-item", function () {
    var value = $(this)
      .attr("orig-value")
      .replace(/[^\w\s]/gi, "");
    value = value.replace(/\s+/g, "-").toLowerCase();
    var styleClass = "style_" + value;

    $(".product__thumb-item").each(function () {
      var group = $(this).attr("data-group") || "";
      $(this).toggle(group.toLowerCase() === styleClass);
    });
  });

  $(document).on(
    "click",
    ".swatch-view-custom-image .swatch-view-item",
    function () {
      var value = $(this).attr("orig-value").replace(/\s+/g, "-").toLowerCase();
      var colorClass = "color_" + value;

      $(".product__thumb-item").each(function () {
        var group = $(this).attr("data-group") || "";
        $(this).toggle(group.toLowerCase() === colorClass);
      });
    }
  );

  $(".shopify-currency-form select").on("change", submitForm);

  setTimeout(function () {
    var colors = {
      "offwhite_50x.png": "#FDF7F4",
      "oat_50x.png": "#E3E1D5",
      "taupe_50x.png": "#9E8A76",
      "rose-dust_50x.png": "#AE9490",
      "peach-pink_50x.png": "#DBBEB7",
      "silver-peony_50x.png": "#C5B3AF",
      "dusty-pink_50x.png": "#C6A4A4",
      "mint-green_50x.png": "#A5B2AA",
      "baby-blue_50x.png": "#9BABBB",
      "sage_50x.png": "#888D82",
      "estate-blue_50x.png": "#36445A",
      "gray_50x.png.png": "#5C525C",
      "silver-cloud_50x.png": "#A09F9C",
      "taupe-gray_50x.png": "#92898A",
      "Capshawl-Duo-DarkGray-1_400x.jpg": "#8D918D",
    };
    $(".grid-product__colors a").each(function () {
      var inlineStyle = $(this).attr('style') || '';
      $.each(colors, function (key, color) {
        if (inlineStyle.indexOf(key) !== -1) {
          $(this).css("background-color", color);
          return false;
        }
      });
    });
  }, 2000);

  setTimeout(function () {
    $(".grid-product__colors a").each(function () {
      var variantImage = $(this).attr("data-variant-image");
      if (!variantImage) return;
      var colors = {
        "Duo-DarkGray": "#8D918D",
        "Duo-Black": "#000000",
        "Duo-LightGray": "#97867c",
        "Duo-Navy": "#000080",
        "Duo-LightPink": "#ffb6c1",
        "Duo-DarkPink": "#AA336A",
        "Duo-White": "#F8F6F0",
        "Duo-Greige": "#f5f5dc",
        "Duo-LightPurple": "#D8BFD8",
        "Duo-DarkPurple": "#301934",
      };
      $.each(colors, function (key, color) {
        if (variantImage.indexOf(key) !== -1) {
          $(this).css("background-color", color);
          return false;
        }
      });
    });
  }, 2000);

  $(".close-video").click(function () {
    $(this).hide();
    $(".video-img-section video").hide();
  });

  // NOTE: Terms & conditions checkout enforcement now lives as a self-contained
  // inline guard in snippets/cart-drawer.liquid (capture-phase submit + click),
  // so it runs independently of this jQuery ready block and covers both the
  // drawer and cart-page checkout forms reliably across devices.

});